import { ProtectedRoute } from './auth/ProtectedRoute';
import UserPage from './UserPage';

export function ProtectedUserPage() {
  return (
    <ProtectedRoute>
      <UserPage />
    </ProtectedRoute>
  );
}

export default ProtectedUserPage;